const BASE_DEV_WEB = "http://localhost:3000";
const BASE_PROD_WEB = "https://hiremebb.grepixinfotech.com/web";

export const BASE_URL_WEB =
  process.env.NODE_ENV === "development" ? BASE_DEV_WEB : BASE_PROD_WEB;

export const websiteDetail = {
  title: "HiremeRides",
  titleValue: "Hireme Rides",
  email: "grepixinfotech@gmail.com",
  countryCode: "+91",
  mobile: "9999999999",
  phoneNumber: "+91-9999999999",
  sharedTitle: "HiremeRides is a global transportation app developed by #",
  quoteTitle: "HiremeRides is a global transportation app developed by #",
  link: "https://hiremebb.grepixinfotech.com",
  linkText: "www.hiremebb.grepixinfotech.com",
  paymentDescription: "Hireme Rides booking website",
  address: "Logix Technova A 328, Plot - A 4, Noida-Greater Noida Expy",
  addressData:
    "Block B, Sector 132, Noida, India - 201304",
};

export const websiteDetailUrl = {
  annoucement: `${BASE_URL_WEB}/announcement-detail`,
  article: `${BASE_URL_WEB}/article-detail`,
  blog: `${BASE_URL_WEB}/blog-detail`,
  imageURL: "https://hiremebb.grepixinfotech.com/api/images/originals/",
  pushNotification:
    "https://hiremebb.grepixinfotech.com/api/api/v1/push2/driver-android-ios-push-notification",
};

export const websiteSocialLinks = {
  facebook: "https://www.facebook.com/#",
  twitter: "https://x.com/#",
  linkedin: "https://linkedin.com/",
  instagram: "https://www.instagram.com/#",
  youtube: "https://www.youtube.com/",
  pinterest: "https://in.pinterest.com/",
  android: "#",
  ios: "#",
};

export const delayData = {
  androidFormDelay: 1500,
  adminFormDelay:1000,
}

export const defaultValues = {
minSeat:1,
maxSeat:10,
seatStep:1,
minPrice:1,
maxPrice:10000,
priceStep:10
}

export const CITY_ID = process.env.REACT_APP_CITY_ID;

export const TagColor = [
  "#EADBDD",
  "#FCD5CE",
  "#FFCAD4",
  "#FADDE1",
  "#FAEDCB"
]

export const mapLibraries = ['places']

// Farex Points - Fare breakdown constants
export const FARE_GST_PERCENT = 5;
export const FARE_ADVANCE_COMMISSION_PERCENT = 10; // Advance = (Base Fare × Commission %) + GST
export const FARE_COMPANY_COMMISSION_PERCENT = 10; // Alias for backward compatibility
export const FARE_PLATFORM_FEE_PERCENT = 10; // Fallback for trip card when estimate not loaded